module.exports = __webpack_public_path__ + "static/media/landscape8.4958f7fe.jpg";